<template>
    <div @contextmenu="preventContext">
        <LoginOverlay v-if="!authorized && !disablePasswordProtection" @authorized="onAuthorized" />
        <div :class="{ 'blurred': !authorized && !disablePasswordProtection }">
            <div @contextmenu="preventContext">
                <router-view @log="logAlert"></router-view>
                <ConfigBox></ConfigBox>
                <div v-if="!this.isIpad" class="footer">
                    <Approval></Approval>
                    <div class="footer-content-box">
                        <p>
                            <span @click="show('privacy')">Privacy Statement</span> /
                            <span @click="show('imprint')">Imprint</span> /
                            <a href="https://pharma.bayer.com/report-side-effect" target="_blank">Report a Side Effect</a>
                        </p>

                    </div>
                </div>

                <LegalModal v-if="!this.isIpad && modals.privacy" @close="onClose" :scroll-to="legalScrollTarget"
                    id="privacy" title="Privacy Statement">
                    <p>This website (hereinafter the “<em class="strong">Website</em>“) is provided by <strong>Bayer
                            Aktiengesellschaft</strong> (hereinafter “<em class="strong">us</em>” or “<em
                            class="strong">we</em>”). For further information regarding the provider of the Website,
                        please refer to our <span class="underline"
                            @click="openFromModal('imprint', 'privacy')">imprint</span>.</p>
                    <h6 class="section">Handling of personal data</h6>
                    <p>In the following we wish to provide you with information on how we handle your personal data when
                        you use our Website. Unless otherwise indicated in the following chapters, the legal basis for
                        the handling of your personal data results from the fact that such handling is required to make
                        available the functionalities of the Website requested by you (Art. 6(1)(b) General Data
                        Protection Regulation).</p>
                    <h6 class="section">Using our Website</h6>
                    <h6>Accessing our Website</h6>
                    <p>When you call up our Website, your browser will transfer certain information to our web server.
                        This is done for technical reasons and required to make available to you the requested
                        information. To facilitate your access to the Website, the following information are collected,
                        briefly stored and used:</p>
                    <ul>
                        <li>IP address</li>
                        <li>date and time of access</li>
                        <li>Time zone difference to Greenwich Mean Time (GMT)</li>
                        <li>Content of request (specific site)</li>
                        <li>Status of access/HTTP status code</li>
                        <li>Transferred volume of data</li>
                        <li>Website requesting access</li>
                        <li>Browser, language settings, version of browser software operating system and surface</li>
                    </ul>
                    <p>Moreover, to protect our legitimate interests, we will store such information for a limited
                        period of time in order to be able to initiate a tracking of personal data in the event of
                        actual or attempted unauthorized access to our servers (Art. 6(1)(f) General Data Protection
                        Regulation).</p>
                    <h6 class="section">Setting of cookies</h6>
                    <h6>What are cookies?</h6>
                    <p>This Website uses so-called “cookies”. Cookies are small text files that are stored in the memory
                        of your terminal via your browser. They store certain information (e.g. your preferred language
                        or site settings) which your browser may (depending on the lifespan of the cookie) retransmit to
                        us upon your next visit to our Website.</p>
                    <h6>What cookies do we use?</h6>
                    <p>We differentiate between two main-categories of cookies: (1) <strong>strictly necessary
                            cookies</strong>, without which the functionality of our Website would be reduced, and (2)
                        <strong>optional cookies</strong> (analytic cookies and functional cookies) used for e.g.
                        website analysis, website personalization and marketing purposes. The following tables contain a
                        detailed description of the optional cookies we use:
                    </p>
                    <h6>Optional Cookies</h6>
                    <table id="cookie-table">
                        <tr class="head">
                            <th class="padded">Name</th>
                            <th>Purpose and Content</th>
                            <th>Lifespan</th>
                            <th class="padded">Provider</th>
                            <th class="padded">Consent</th>
                        </tr>
                        <tr>
                            <td>Website <br />analysis <br />with Google</td>
                            <td><strong>Website analysis with Google</strong><br /><br />These cookies assign a randomly
                                generated ID to your device, enabling us to recognize your device upon your next access.
                                For details on website analysis with Google, please see the respective chapter below.
                            </td>
                            <td>6 months</td>
                            <td>Google Inc.</td>
                            <td>
                                <div class="cookie-toggles">
                                    <span :class="['on', { active: cookieButtonState }]"
                                        @click="toggleCookieButton">ON</span>/<span
                                        :class="['off', { active: !cookieButtonState }]"
                                        @click="toggleCookieButton">OFF</span>
                                </div>
                            </td>
                        </tr>
                    </table>
                    <h6>Subject to your consent</h6>
                    <p>We only use optional cookies if we have obtained your prior consent (Art. 6(1)(a) General Data
                        Protection Regulation). Upon your first access to our Website, a banner will appear, asking you
                        to give us your consent to the setting of optional cookies. If your consent is given, we will
                        place a cookie on your computer and the banner will not appear again as long as the cookie is
                        active. After expiration of the cookie’s lifespan, or if you actively delete the cookie, the
                        banner will reappear upon your next visit to our Website and again ask for your consent.</p>
                    <h6>How to prevent the setting of cookies</h6>
                    <p>Of course, you may use our Website without any cookies being set. In your browser, you can at any
                        time configure or completely deactivate the use of cookies. This may, however, lead to a
                        restriction of the functions or have adverse effects on the user-friendliness of our Website.
                        You may at any time object to the setting of optional cookies by using the respective objection
                        option indicated in the table above.</p>
                    <h6>Website Analysis with Google</h6>
                    <p>On our Website we use a web analysis service of Google Inc., 1600 Amphitheatre Parkway, Mountain
                        View, CA 94043, United States („Google“).</p>
                    <p>Google will analyze your use of our Website on our behalf. To this purpose, we use the cookies
                        described in more detail in the above table. The information collected by Google in connection
                        with your use of our Website (e.g. the referring URL, our webpages visited by you, your browser
                        type, your language settings, your operating system, your screen resolution) will be transmitted
                        to a server of Google in the US, where it will be stored and analyzed. The respective results
                        will then be made available to us in anonymized form. Your usage data will not be connected to
                        your full IP address during this process. We have activated on our Website the IP anonymizing
                        function offered by Google, which will delete the last 8 bits (type IPv4) or the last 80 bits
                        (type IPv6) of your IP address after each data transfer to Google.</p>
                    <p>Moreover, by concluding specific agreements with Google we ensure that an adequate level of data
                        protection is maintained with respect to the processing of personal data by Google in the US.
                    </p>
                    <p>You may withdraw your consent to the use of web analysis at any time, either by downloading and
                        installing the provided <a href="https://tools.google.com/dlpage/gaoptout?hl=en-GB"
                            target="_blank">Google Browser Plugin</a> or by administrating your consents in the above
                        table, in which case an opt-out cookie will be placed. Both options will prevent the application
                        of web analysis only as long as you use the browser on which you installed the plugin and do not
                        delete the opt-out Cookie.</p>
                    <h6 class="section">Information on side effects and quality complaints</h6>
                    <p>This Website is not intended or designed for communications regarding side effects, lack of
                        therapeutic effect, medication errors, grey market products/counterfeit medicine, incorrect or
                        off-label use, quality complaints and/or other issues regarding the safeness or quality of Bayer
                        products. If you wish to report side effects or make a quality complaint, please contact your
                        health care professional (e.g. physician or pharmacist), your local health authority, or use our
                        <a href="https://pharma.bayer.com/report-side-effect" target="_blank">Website</a> for the report
                        of undesirable side effects.
                    </p>
                    <p>If you nevertheless report to us undesirable side effects or other issues regarding the safeness
                        or quality of Bayer products, we will be legally bound to deal with your communication and may
                        have to contact you for clarification purposes. Subsequently, we may have to notify the
                        competent health authorities of the issues reported by you. In this context, your information
                        will be forwarded in pseudonymized form, i.e. no information by which you may be directly
                        identified will be passed on. We may also have to forward these pseudonymized notifications to
                        our group companies and cooperation partners, to the extent these are likewise obliged to notify
                        their respectively competent health authorities.</p>
                    <h6 class="section">Information regarding your rights</h6>
                    <p>The following rights are in general available to you according to applicable data privacy laws:
                    </p>
                    <ul>
                        <li>Right of information about your personal data stored by us;</li>
                        <li>Right to request the correction, deletion or restricted processing of your personal data;
                        </li>
                        <li>Right to object to a processing for reasons of our own legitimate interest, public interest,
                            or profiling , unless we are able to prove that compelling, warranted reasons superseding
                            your interests, rights and freedom exist, or that such processing is done for purposes of
                            the assertion, exercise or defense of legal claims;</li>
                        <li>Right to data portability;</li>
                        <li>Right to file a complaint with a data protection authority;</li>
                        <li>You may at any time with future effect withdraw your consent to the processing of your
                            personal data. For further information please refer to the chapters above describing the
                            processing of personal data based on your consent.</li>
                    </ul>
                    <p>If you wish to exercise your rights, please address your request to the contact indicated below.
                        (-> Contact).</p>
                    <h6 class="section">Contact</h6>
                    <p>For any questions you may have with respect to data privacy, please write an email to
                        support@cv-lr.com or contact our company data protection officer at the following address:</p>
                    <p class="centered">Group Data Protection Officer Bayer <br /><br />AG <br /><br />51368 Leverkusen
                        <br />
                    </p>
                    <h6 class="section">Amendment of Privacy Statement</h6>
                    <p>We may update our Privacy Statement from time to time. Updates of our Privacy Statement will be
                        published on our Website. Any amendments become effective upon publication on our Website. We
                        therefore recommend that you regularly visit the site to keep yourself informed on possible
                        updates.</p>
                    <p>Last updated: <strong>14.09.2021</strong>.</p>
                    <br />
                </LegalModal>
                <LegalModal @close="onClose" v-if="!this.isIpad && modals.imprint" id="imprint" title="Imprint">
                    <h6>Published by:</h6>
                    <p>
                        Bayer AG, Leverkusen, Germany<br />
                        represented by the Management Board:<br />
                        Bill Anderson, Chairman<br />
                        Wolfgang Nickl, Stefan Oelrich, Heike Prinz, Rodrigo Santos, Julio Triana
                    </p>
                    <p>
                        Kaiser-Wilhelm-Allee 1<br />
                        51373 Leverkusen, Germany<br />
                        Tel.: +49 (0)214 30-1<br />
                        E-mail: Inquiries can be sent to <a style="color: #003b33;" target="_blank"
                            href="mailto:info@bayer.com"><u>info@bayer.com</u></a> or
                        using our <a style="color: #003b33;" target="_blank"
                            href="https://www.bayer.com/en/contact-us"><u>contact
                                form</u></a>
                    </p>
                    <p>
                        Entry in the Commercial Register of the Cologne District Court <br />
                        (Amtsgericht): HRB 48248 <br />
                        Turnover tax ID no.: DE 123659859
                    </p>
                    <br />

                </LegalModal>
                <Cookies v-if="!this.isIpad" @open="showCookiePolicy"></Cookies>
            </div>
        </div>
    </div>
</template>

<script>

import Approval from './components/Approval.vue';
import LegalModal from './components/LegalModal.vue';
import ConfigBox from './components/ConfigBox.vue';
import Cookies from './components/Cookies.vue';
import LoginOverlay from './components/LoginOverlay.vue';


export default {
    name: 'app',
    data: function () {
        return {
            vm: this,
            modals: {
                privacy: false,
                imprint: false
            },
            legalScrollTarget: null,
            showCookies: false,
            cookieButtonState: false,
            disablePasswordProtection: false,
            authorized: localStorage.getItem('authorized') === 'true',

        }
    },
    components: {
        Approval,
        ConfigBox,
        LegalModal,
        Cookies,
        LoginOverlay
    },
    beforeMount: function () {
        this.$store.dispatch('setEventId', JSON.parse(window.localStorage.getItem('appEventId')));
        this.$store.dispatch('setDisclaimerContent');
        this.$store.dispatch('setPageData');
        this.$store.dispatch('setProductNames');
        this.$store.dispatch('setDiseaseStates');
        this.$store.dispatch('setPhases');
        this.$store.dispatch('setApproval');
        this.$store.dispatch('storeTrialLogos');
        this.$store.dispatch('setEvents');
        this.$store.dispatch('setDefaultApprovalCode');
    },
    mounted() {
        window.appp = this;
        this.initCookies();
    },
    computed: {
        trackUrls: function () { // Deprecated
            return this.getTrackUrls();
        }
    },
    methods: {
        getTrackUrls: function () { // Deprecated
            return this.$root.trackSpool;
        },
        preventContext(event) {
            event.preventDefault();
        },
        logAlert(value) {
            let modal = '';
            if (value.modal !== null) {
                modal = ' - ' + value.modal
            }
            let page = 'Timeline - ' + value.trialName + ' - ' + value.tabName + modal;
            this.$root.track("callback://screenname_" + page);
        },
        setUpGoogleAnalytics() {

        },
        showCookiePolicy: function () {
            this.legalScrollTarget = 'cookie-table';
            this.show('privacy');
        },
        show: function (id) {
            if (id === 'privacy') {
                this.cookieButtonState = this.analytics.getOptInState();
            }
            this.modals[id] = true;
        },
        openFromModal: function (open, close) {
            this.modals[close] = false;
            this.modals[open] = true;
        },
        onClose: function (id) {
            this.legalScrollTarget = null;
            this.modals[id] = false;
        },
        initCookies: function () {
            this.analytics.init();
            const cookies = this.analytics.getConsentCookie();
            if (cookies !== -1) {
                this.setCookieState(cookies);
            } else {
                this.showCookies = true;
            }
        },
        toggleCookieButton: function (event) {
            const state = event.target.classList.contains('on');
            this.setCookieState(state);
        },
        setCookieState: function (state) {
            this.analytics.setOptInState(state);
            this.cookieButtonState = this.analytics.getOptInState();
            this.showCookies = false;
        },
        onAuthorized() {
            this.authorized = true;
        }
    }
}  
</script>

<style>
.blurred {
    filter: blur(10px);
    pointer-events: none;
    user-select: none;
}

html.is-fit-width,
html.is-fit-width body,
html.is-fit-width #app,
body.timeline-page,
body.timeline-page #app {
    overflow-x: hidden;
    max-width: 100%;
    width: 100%;
}

body.timeline-page,
body.timeline-page #app,
body.timeline-page .content-container {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
}

body.timeline-page .content-container,
body.timeline-page .content-container > .container {
    overflow-x: hidden;
    overflow-y: hidden;
    max-width: 100% !important;
    min-width: 0;
    width: 100% !important;
}

body.timeline-page .navbar {
    width: 100% !important;
    max-width: 100% !important;
}

body.timeline-page .content-container.desktop {
    padding-bottom: 4.8em !important;
}

.timeline-shell {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    min-height: 0;
    height: calc(100% - 120px);
    margin-top: 30px;
}

@media (max-width: 1919px) {
    .timeline-shell {
        margin-top: 70px;
    }
}

@media (min-width: 1920px) {
    .timeline-shell {
        height: calc(100% - 133px);
        margin-top: 0;
    }
}

.timeline {
    display: block !important;
    box-sizing: border-box !important;
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    overflow-x: auto !important;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch;
    touch-action: pan-x;
    transform: translateZ(0);
    height: auto !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    padding-bottom: 0;
    scrollbar-width: none;
}

.timeline-track {
    display: flex !important;
    flex-wrap: nowrap;
    align-items: stretch;
    flex: 0 0 auto;
    width: max-content !important;
    max-width: none !important;
    min-width: max-content !important;
    height: 100%;
    vertical-align: top;
}

.timeline-end-spacer {
    flex: 0 0 28vw;
    min-width: 160px;
    pointer-events: none;
}

.timeline::-webkit-scrollbar {
    display: none !important;
    height: 0 !important;
    width: 0 !important;
}

.timeline-h-scroll {
    position: fixed !important;
    left: 24px;
    right: 24px;
    bottom: 4.6em;
    z-index: 15;
    flex: 0 0 16px;
    height: 16px;
    margin: 0;
    background: #d9d9d9;
    border-radius: 10px;
    cursor: pointer;
    overflow: hidden;
    touch-action: none;
}

.timeline-h-scroll-thumb {
    position: absolute;
    top: 2px;
    bottom: 2px;
    left: 0;
    min-width: 48px;
    background: #003b33;
    border-radius: 10px;
    cursor: grab;
}

.content-container.ipad:not(.desktop) .timeline-h-scroll {
    bottom: 16px;
}

.footer {
    display: flex !important;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    min-height: 3.6em;
}

.footer .timeline-approval-text {
    text-align: left !important;
    width: auto !important;
    max-width: none !important;
    float: none !important;
    margin-left: 0 !important;
    margin-right: auto;
    flex: 0 1 auto;
}

.footer-content-box {
    width: auto !important;
    float: none !important;
    text-align: right !important;
    white-space: nowrap;
    flex: 0 0 auto;
}

.footer-content-box p {
    margin: 0;
    white-space: nowrap;
}
</style>
